{"NG_APP_ETRAM_ENCRYPTION_KEY":"e3d6d76b5cee460ad9dc756c21262d144c60ecb1b998ea145ff9e98bf3482829"}